

































import { Component, Vue } from "vue-property-decorator";
import LoginNavigation from "@/components/auth/LoginNavigation.vue";

/**
 * Viewコンポーネント
 * Indexページ：ユーザーログインを通してコンテンツへのロビー機能を提供する
 */
@Component({
  components: {
    LoginNavigation
  }
})
export default class Indexpage extends Vue {
  /**
   * 既にログインしているかどうかを取得
   */
  get isLoggedIn (): boolean {
    return this.$store.state.isLoggedIn;
  }

  /**
   * 初回のユーザーログインチェックを通っているかどうかを取得
   */
  get isFirstUserCheck (): boolean {
    return this.$store.state.isFirstUserCheck
  }

}
